import Cookies from 'js-cookie';
import { refreshToken, logout } from '../../Redux/Auth/authActions'; 
import * as ActionTypes from '../Constants/actionTypes';
import { setupTokenRefreshTimeout } from './tokenUtils';
import {jwtDecode} from 'jwt-decode';

let tokenRefreshTimeout;  // Declare this at the top level to avoid 'undefined' errors

const tokenMiddleware = ({ dispatch }) => next => async action => {
    const accessToken = Cookies.get('accessToken');
    
    if (accessToken && ![ActionTypes.LOGIN_REQUEST, ActionTypes.REFRESH_TOKEN_SUCCESS, ActionTypes.LOGOUT].includes(action.type)) {
        const decodedToken = jwtDecode(accessToken);
        const tokenExpiry = decodedToken.exp * 1000; // Convert to milliseconds

        // Automatically schedule token refresh
        setupTokenRefreshTimeout(tokenExpiry, dispatch, refreshToken, logout);  // Add refreshToken and logout
    }

    // Clear the token refresh timeout on logout
    if (action.type === ActionTypes.LOGOUT) {
        if (tokenRefreshTimeout) {
            clearTimeout(tokenRefreshTimeout);
        }
    }

    return next(action);
};

export default tokenMiddleware;
